// Accepts only letters and dots, with a minimum length of 2
export const isLegitI18NKey = (key: string) => /^[a-zA-Z.]{2,}$/.test(key)
